<style lang="scss" scoped>
@import '@@/assets/css/global.scss';
.container {
  margin-top: 20px;
}
</style>
<template>
  <div v-loading="loading">
    <div class="title">{{ $t('xiaoshichanliang') }}</div>
    <div class="clChart" style="margin-top: 30px;" id="clChart"></div>

    <div class="title" style="margin-top: 40px;">{{ $t('dangrizhuangtai') }}</div>
    <div class="stateChart" style="margin-top: 20px;" id="stateChart"></div>
  </div>
</template>

<script>
export default {
  name: 'gongdan_zhuangtai',
  components: {},
  props: {
    sn: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: false,
      clChart: null,
      stateChart: null
    };
  },

  computed: {
    ...Vuex.mapState(['equipmentsMap']),
    eq() {
      return this.equipmentsMap[this.sn];
    }
  },
  watch: {
    sn(n, o) {
      this.getHourCl();
      this.getStates();
    }
  },
  created() {},
  mounted() {
    this.initClChart();
    this.initStateChart();

    this.getHourCl();
    this.getStates();
  },
  beforeDestroy() {},

  methods: {
    initClChart() {
      let data = [];
      const chart = new G2.Chart({
        container: 'clChart',
        autoFit: true,
        height: 120,
        padding: [20, 20, 20, 20]
      });
      chart.scale('value', {
        alias: '产量'
      });

      chart.scale('hour', {
        tickCount: 24
      });

      chart.axis('hour', {
        tickLine: {
          alignTick: false
        }
      });

      chart.axis('value', false);

      chart.tooltip({
        showMarkers: false
      });
      chart
        .interval()
        .position('hour*value')
        .label('value');
      chart.interaction('element-active');

      // 添加文本标注
      // data.forEach(item => {
      // 	chart.annotation().text({
      // 		position: [item.hour, item.value],
      // 		content: item.value,
      // 		style: {
      // 			textAlign: 'center',
      // 		},
      // 		offsetY: -30,
      // 	});
      // });
      chart.render();
      this.clChart = chart;
    },

    initStateChart() {
      let chart = new G2.Chart({
        container: 'stateChart',
        autoFit: true,
        height: 80,
        padding: [20, 20, 20, 20]
      });

      chart.coordinate('rect').transpose();
      chart.interaction('active-region');
      const geometry = chart
        .interval()
        .adjust('stack')
        .position('name*interval');
      // 此处必须有stStr,作为每段数据的唯一标识,且必须是字符串!
      geometry.color('stStr*s', (stStr, s) => {
        if (s == 0 || s == 2) {
          return '#54fb8d';
        } else if (s == 3) {
          return '#f67b7d';
        } else if (s == 1) {
          return '#fee47d';
        } else if (s == -1) {
          return '#919191';
        }
      });

      chart.axis('name', {
        title: null,
        label: null
      });
      chart.scale('interval', {
        min: 0,
        max: 24,
        tickCount: 25
      });
      chart.tooltip({
        // shared: true,
        showTitle: false,
        showMarkers: false,
        itemTpl: `<li style="margin-bottom:12px">{state}:{interval}</li>`
      });
      // 自定义提示框显示内容
      geometry.tooltip('s*interval', (s, interval) => {
        let state;
        if (s == 0 || s == 2) {
          state = this.$t('yunxing');
        } else if (s == 3) {
          state = this.$t('gz');
        } else if (s == 1) {
          state = this.$t('kx');
        } else if (s == -1) {
          state = this.$t('lixian');
        }
        return {
          state: state,
          interval: Number(interval * 60).toFixed(0) + 'min'
        };
      });
      chart.legend(false); // 取消显示图例

      chart.render();

      this.stateChart = chart;
    },

    getHourCl() {
      let rclCmsCode = this.eq.codePointsMap.rcl.cmsCode;
      if (!rclCmsCode) {
        return;
      }
      let params = {
        sn: this.sn,
        cmsPoint: rclCmsCode,
        interval: 60,
        begin: dayjs()
          .startOf('day')
          .valueOf(),
        end: dayjs()
          .startOf('day')
          .add(1, 'days')
          .valueOf()
      };
      this.http
        .get('/cms/influxdb/getSpreadGroupByTimeInterval?' + this.qs.stringify(params))
        .then(res => {
          console.log(res);

          let data = [];
          for (let i = 0; i < res.length; i++) {
            data.push({
              hour: i,
              value: res[i].spread
            });
          }
          console.log(this.clChart);
          this.clChart.data(data);
          this.clChart.render();
        })
        .catch(err => {
          alert(err);
          this.utils.errorMessage(err);
        })
        .finally(() => {});
    },
    getStates() {
      this.loading = true;
      let statePoint = this.eq.codePointsMap['CurrentState'].cmsCode;
      if (!statePoint) {
        return;
      }

      let params = {
        sn: this.sn,
        statePoint: statePoint,
        interval: 60,
        begin: dayjs()
          .startOf('day')
          .valueOf(),
        end: dayjs()
          .startOf('day')
          .add(1, 'days')
          .valueOf()
      };
      this.http
        .get('/cms/influxdb/getEquipmentState?' + this.qs.stringify(params))
        .then(res => {
          console.log(res);

          let data = [];
          res.map(ele => {
            let obj = {};
            obj.name = this.$t('drzt');
            //如果没有et, dayjs(undefined)默认取当前时间
            obj.st = dayjs(ele.st);
            obj.et = !ele.et ? (dayjs(ele.st) > dayjs() ? dayjs(ele.st) : dayjs()) : dayjs(ele.et);
            obj.s = ele.s;
            obj.interval = Math.round((obj.et.diff(obj.st) / 3600000) * 1000000) / 1000000; // 计算时间差,保留6位小数,小数位要多留,不然记录过多的时候,相加值就不准

            /*(这条已注释)减少状态变更过于频繁导致的状态条不好看,过滤掉变更时长小于2分钟的数据
             * 但过滤之后产生新的问题,原本后台不会返回连续相同状态的数据,过滤后就会有连续相同的数据,因此,还要把连续相同的数据合并起来,顺便把状态为0和2的数据也合并;
             * 过滤和合并的操作实质上都是把后一条数据的结束时间和持续时长合并到前一条
             * */
            let lastObj = data[data.length - 1];
            if (
              lastObj !== undefined &&
              // (obj.et.diff(obj.st, 'minutes') < 2) ||
              (lastObj.s === obj.s || (lastObj.s == 0 && obj.s == 2) || (lastObj.s == 2 && obj.s == 0))
            ) {
              lastObj.et = obj.et;
              lastObj.interval = lastObj.interval + obj.interval;
            } else {
              // if (obj
              // 此字段用于color("stStr"),必须是字符串
              obj.stStr = obj.st.format();
              data.push(obj);
            }
          });
          this.stateChart.data(data);
          this.stateChart.render();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
